import React, {useEffect, useState} from 'react';
import styles from './styles.module.scss';
import Image from 'next/image';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCircleQuestion, faArrowRight} from '@fortawesome/pro-regular-svg-icons';
import {Button, Input, Tooltip} from 'antd';
import {NextImg} from '@/utils/nextImg';
import {getDomain} from '@/utils/url';
import {useStore} from '@/store/root-store';
interface StepOneProps {
  onRunDiagnostics: (url: string) => void;
  setVisible: (visible: boolean) => void;
  record: any;
}


function hasValidSlashes(str) {
  return !str.startsWith('/') && !str.includes('//');
}

function isUrlValid(userInput) {
  // eslint-disable-next-line no-useless-escape
  const res = userInput.match(/^https:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/);
  if (res == null) {
    return false;
  } else {
    return true;
  }
}

export const StepOne: React.FC<StepOneProps> = ({onRunDiagnostics, setVisible, record}) => {
  const [isValidPath, setIsValidPath] = useState(true);
  const {settings: {customer: {profile: {whitelabelOtto}}}} = useStore('');
  const [url, setUrl] = useState('');

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    validatePath(url);
  }, [url]);

  const domainName = record?.hostname;

  const validatePath = (path: string) => {
    const updatedUrlValue = path?.startsWith('/') ? path?.slice(1) : path;
    const updatedUrl = `${domainName}/${updatedUrlValue}`?.startsWith('http://') ? `${domainName}/${updatedUrlValue}` : `https://${domainName}/${updatedUrlValue}`;
    if (!path?.length) {
      setIsValidPath(true);
      return true;
    }
    if (!updatedUrl?.trim() || !hasValidSlashes(path) || !isUrlValid(updatedUrl)|| path?.trim()?.includes(' ')) {
      setIsValidPath(false);
      return false;
    }
    setIsValidPath(true);
    return true;
  };

  return (
    <div className={styles.wrapper} style={{padding: '24px 16px'}}>
      <div style={{display: 'flex', gap: '10px'}}>
        <Image src={'/img/DiagnosticsLogo.svg'} alt='Installation Diagnostics' width={70} height={70}/>
        <div>
          <h3 className={styles.title} id='diagnostic-modal-title'>
            {/* <FontAwesomeIcon icon={faGlobe} className={styles.icon} /> */}
            Installation Diagnostics
          </h3>
          <p className={styles.description}>
            Paste the URL of the page you want to check. We&apos;ll run a technical diagnostics and identify any issues related to {whitelabelOtto} implementation. A detailed report will be generated shortly.
          </p>
        </div>
      </div>
      <div>
        <div className={styles.label}>
          <p>Page URL</p>
          <Tooltip title='Enter the full URL of the page you want to diagnose.'>
            <FontAwesomeIcon icon={faCircleQuestion} className={styles.infoIcon} />
          </Tooltip>
        </div>
        <div className={styles.inputWrapper}>
          <div className={styles.domainWrapper}>
            <NextImg style={{height: '20px', width: '20px', borderRadius: '4px'}} src={`https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=${domainName && getDomain((!/^(https?:)?\/\//i.test(domainName)) ? 'https:' + domainName : domainName)}&size=64`}/>
            <p className={styles.domainText}>{record?.hostname}{!record?.hostname.endsWith('/') && '/' }</p>
          </div>
          <Input
            value={url}
            autoFocus
            onChange={e => {
              setUrl(e.target.value);
            }}
            status={!isValidPath ? 'error' : ''}
          />
        </div>
        {!isValidPath && (
          <div style={{color: 'red', fontSize: '12px', marginTop: '4px'}}>
              Please enter a valid path
          </div>
        )}
      </div>
      <div className={styles.footer}>
        <Button
          className={styles.cancelButton}
          onClick={handleCancel}
          aria-label='Cancel'
        >
            Cancel
        </Button>
        <Button
          onClick={()=>{
            onRunDiagnostics(url);
          }}
          className={styles.runButton}
          aria-label='Run Diagnostics'
          disabled={!isValidPath}
        >
            Run Diagnostics
          <FontAwesomeIcon icon={faArrowRight} style={{marginLeft: 10}} />
        </Button>
      </div>
    </div>
  );
};
